import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * CATIA-sınıfı Pad/Pocket Definition penceresi (FikoDialogCore içeriği).
 * First/Second Limit (Type+Length+Offset) · Thin Pad · Draft+Fillet · Direction (Reverse/Mirrored) · canlı önizleme.
 * DialogCore başlık+kapat chrome'unu sağlar; bu component yalnız gövdeyi + Tamam/İptal'i çizer.
 */
@Component({
  selector: 'fikoyt-pad-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="pd" *ngIf="el && yon">

    <!-- BİRİNCİ LİMİT -->
    <div class="pd-grup">
      <div class="pd-bas">Birinci Limit</div>
      <div class="pd-row"><label>Tür</label>
        <select [ngModel]="el.limitTip || 'boyut'" (ngModelChange)="set('limitTip',$event)">
          <option value="boyut">Ölçü (Dimension)</option>
          <option value="sonraki">Bir Sonrakine (Up to Next)</option>
          <option value="son">Sonuncuya (Up to Last)</option>
          <option value="duzleme">Düzleme (Up to Plane)</option>
        </select>
      </div>
      @if((el.limitTip||'boyut')==='boyut'){
        <div class="pd-row"><label>{{pocket?'Derinlik':'Uzunluk'}}</label><div class="pd-num"><input type="number" min="0.1" step="1" [ngModel]="el.param ?? 20" (ngModelChange)="setNum('param',$event)"/><span>mm</span></div></div>
      } @else {
        @if(el.limitTip==='duzleme'){
          <button class="pd-btn" (click)="hedefSec()">🎯 Hedef Yüz/Düzlem Seç @if(el.limitHedefMesafe!=null){ ({{el.limitHedefMesafe|number:'1.0-0'}}mm) }</button>
        }
        <div class="pd-row"><label>Ofset</label><div class="pd-num"><input type="number" step="1" [ngModel]="el.ofset1 ?? 0" (ngModelChange)="setNum('ofset1',$event)"/><span>mm</span></div></div>
      }
    </div>

    <!-- MULTI-PAD: çoklu bölge → her bölgeye ayrı boy -->
    @if(domainSayisi()>1){
      <div class="pd-grup">
        <div class="pd-bas">Bölgeler — Multi-Pad ({{domainSayisi()}})</div>
        @for(i of domainIndis(); track i){
          <div class="pd-row">
            <label class="pd-dom"><input type="checkbox" [ngModel]="domainAcik(i)" (ngModelChange)="toggleDomain(i,$event)"/> Bölge {{i+1}}</label>
            <div class="pd-num"><input type="number" min="0.1" step="1" [disabled]="!domainAcik(i)" [ngModel]="domainBoy(i)" (ngModelChange)="setDomain(i,$event)"/><span>mm</span></div>
          </div>
        }
      </div>
    }

    <!-- İKİNCİ LİMİT -->
    <div class="pd-grup">
      <label class="pd-chk"><input type="checkbox" [ngModel]="!!el.limit2Aktif" (ngModelChange)="set('limit2Aktif',$event)"/> İkinci Limit (ters yön)</label>
      @if(el.limit2Aktif){
        <div class="pd-row"><label>Tür</label>
          <select [ngModel]="el.limit2Tip || 'boyut'" (ngModelChange)="set('limit2Tip',$event)">
            <option value="boyut">Ölçü</option><option value="son">Sonuncuya</option><option value="sonraki">Bir Sonrakine</option>
          </select>
        </div>
        @if((el.limit2Tip||'boyut')==='boyut'){
          <div class="pd-row"><label>Uzunluk</label><div class="pd-num"><input type="number" min="0" step="1" [ngModel]="el.param2 ?? 0" (ngModelChange)="setNum('param2',$event)"/><span>mm</span></div></div>
        }
      }
    </div>

    <!-- İNCE DUVAR (Thin Solid) -->
    <div class="pd-grup">
      <label class="pd-chk"><input type="checkbox" [ngModel]="!!el.incePad" (ngModelChange)="set('incePad',$event)"/> İnce Duvar (Thin Solid)</label>
      @if(el.incePad){
        <div class="pd-row"><label>Et Kal. 1 (içe)</label><div class="pd-num"><input type="number" min="0" step="0.5" [ngModel]="el.padKal1 ?? 2" (ngModelChange)="setNum('padKal1',$event)"/><span>mm</span></div></div>
        @if(!el.notrFiber){
          <div class="pd-row"><label>Et Kal. 2 (dışa)</label><div class="pd-num"><input type="number" min="0" step="0.5" [ngModel]="el.padKal2 ?? 0" (ngModelChange)="setNum('padKal2',$event)"/><span>mm</span></div></div>
        }
        <label class="pd-chk"><input type="checkbox" [ngModel]="!!el.notrFiber" (ngModelChange)="set('notrFiber',$event)"/> Neutral Fiber (eşit iki taraf)</label>
      }
    </div>

    <!-- YÖN -->
    <div class="pd-grup">
      <div class="pd-bas">Yön</div>
      <div class="pd-row"><label>Uzatma Yönü</label>
        <select [ngModel]="yonSec()" (ngModelChange)="setYon($event)">
          <option value="normal">Sketch Normali</option>
          <option value="x">X Ekseni</option>
          <option value="y">Y Ekseni</option>
          <option value="z">Z Ekseni</option>
          <option value="3d">3D Yüzeyden…</option>
        </select>
      </div>
      <button class="pd-btn" (click)="yonHedefSec()">🎯 Yönü 3D Yüzeyden Seç @if(yonSec()==='3d'){ ✓ }</button>
      <label class="pd-chk"><input type="checkbox" [ngModel]="!!el.simetrik" (ngModelChange)="set('simetrik',$event)"/> Simetrik Uzat (Mirrored Extent)</label>
      <button class="pd-btn" [class.aktif]="el.tersYon" (click)="set('tersYon',!el.tersYon)">⇅ Yön Çevir (Reverse)</button>
    </div>

    <div class="pd-altbar">
      <button class="pd-btn pd-ok" (click)="tamam()">✔ Tamam</button>
      <button class="pd-btn pd-sil" (click)="sil()">🗑 Sil</button>
    </div>
  </div>
  `,
  styles: [`
    .pd{padding:6px 10px 10px;color:#dbe4f0;font:500 12px/1.4 system-ui,sans-serif;min-width:230px;}
    .pd-grup{border-top:1px solid rgba(120,160,255,.16);padding:6px 0 3px;}
    .pd-grup:first-child{border-top:none;}
    .pd-bas{font-size:10px;font-weight:800;color:#7db0ff;text-transform:uppercase;letter-spacing:.5px;margin:0 0 5px;}
    .pd-row{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:3px 0;}
    .pd-row label{font-size:11.5px;color:#aab8cc;}
    .pd-row select{flex:1;max-width:150px;background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;font-size:11px;cursor:pointer;outline:none;}
    .pd-num{display:flex;align-items:center;gap:4px;}
    .pd-num input{width:62px;background:rgba(0,0,0,.4);color:#fff;font-weight:700;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;outline:none;}
    .pd-num input:focus{border-bottom-color:#00d0ff;background:rgba(0,60,80,.5);}
    .pd-num span{color:#00d0ff;font-size:10px;}
    .pd-chk{display:flex;align-items:center;gap:7px;font-size:11.5px;color:#cbd5e1;cursor:pointer;padding:3px 0;}
    .pd-chk input{accent-color:#00d0ff;cursor:pointer;width:14px;height:14px;}
    .pd-dom{display:flex;align-items:center;gap:6px;font-size:11px;color:#aab8cc;cursor:pointer;}
    .pd-dom input{accent-color:#00d0ff;cursor:pointer;}
    .pd-num input:disabled{opacity:.4;}
    .pd-btn{width:100%;margin-top:4px;background:rgba(20,40,60,.7);color:#cfe6f5;border:1px solid rgba(0,200,255,.3);border-radius:6px;padding:5px;font-size:11.5px;font-weight:600;cursor:pointer;transition:all .15s;}
    .pd-btn:hover{background:rgba(0,150,200,.4);border-color:#00d0ff;}
    .pd-btn.aktif{background:rgba(0,200,255,.3);border-color:#00d0ff;color:#fff;}
    .pd-altbar{display:flex;gap:6px;margin-top:8px;}
    .pd-altbar .pd-btn{margin-top:0;}
    .pd-ok{background:rgba(20,120,80,.55);border-color:rgba(52,211,153,.5);color:#a7f3d0;}
    .pd-ok:hover{background:rgba(20,160,100,.7);}
    .pd-sil{flex:0 0 70px;background:rgba(120,30,30,.5);border-color:rgba(239,68,68,.5);color:#fca5a5;}
    .pd-sil:hover{background:rgba(160,40,40,.7);}
  `]
})
export class FikoPadDialog {
  @Input() element: any;   // IOzellik (pad/pocket)
  @Input() yonetici: any;  // FikoModellemeYonetici
  @Input() pencere: any;   // FikoDialogCore (kapatmak için)
  get el() { return this.element; }
  get yon() { return this.yonetici; }
  get pocket(): boolean { return this.element?.tip === 'pocket'; }

  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }

  // Multi-Pad domain tablosu
  domainSayisi(): number { return this.yonetici?.padDomainSayisi?.(this.element) || 0; }
  domainIndis(): number[] { return Array.from({ length: this.domainSayisi() }, (_, i) => i); }
  domainBoy(i: number): number { return this.element?.domainBoy?.[i] ?? this.element?.param ?? 20; }
  domainAcik(i: number): boolean { return !this.element?.domainKapali?.[i]; }   // Profile Definition Sub: dahil mi
  toggleDomain(i: number, acik: any): void {
    const n = this.domainSayisi();
    if (!this.element.domainKapali || this.element.domainKapali.length !== n) this.element.domainKapali = new Array(n).fill(false);
    this.element.domainKapali[i] = !acik;
    this.yonetici?.padGuncelle(this.element, 'domainKapali', this.element.domainKapali.slice()); this.CD.markForCheck();
  }
  setDomain(i: number, v: any): void {
    const n = this.domainSayisi(); if (!this.element.domainBoy || this.element.domainBoy.length !== n) this.element.domainBoy = this.domainIndis().map(k => this.domainBoy(k));
    this.element.domainBoy[i] = +v;
    this.yonetici?.padGuncelle(this.element, 'domainBoy', this.element.domainBoy.slice()); this.CD.markForCheck();
  }

  // Direction Reference: sketch normali, X/Y/Z ekseni veya 3D yüzeyden
  yonSec(): string {
    if (!this.element?.refYonAktif || !this.element?.refYon) return 'normal';
    const r = this.element.refYon; const ax = Math.abs(r.x), ay = Math.abs(r.y), az = Math.abs(r.z);
    if (ax > 0.99) return 'x'; if (ay > 0.99) return 'y'; if (az > 0.99) return 'z'; return '3d';
  }
  setYon(v: string): void {
    if (v === 'normal') { this.element.refYonAktif = false; this.yonetici?.padGuncelle(this.element, 'refYonAktif', false); }
    else if (v === '3d') { this.yonHedefSec(); return; }
    else { const yon = v === 'x' ? { x: 1, y: 0, z: 0 } : v === 'y' ? { x: 0, y: 1, z: 0 } : { x: 0, y: 0, z: 1 }; this.element.refYon = yon; this.element.refYonAktif = true; this.yonetici?.padGuncelle(this.element, 'refYon', yon); }
    this.CD.markForCheck();
  }
  yonHedefSec(): void { this.yonetici?.yonHedefSecBaslat?.(this.element); }

  set(anahtar: string, deger: any): void { this.yonetici?.padGuncelle(this.element, anahtar, deger); this.CD.markForCheck(); }
  setNum(anahtar: string, deger: any): void { const v = +deger; if (!isNaN(v)) this.yonetici?.padGuncelle(this.element, anahtar, v); this.CD.markForCheck(); }
  hedefSec(): void { this.yonetici?.limitHedefSecBaslat?.(this.element); }
  private kapat(): void { (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
